"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var billingFormStyles = {
  container: {
    flywire: {
      middleLeft: {
        minHeight: 0,
        paddingLeft: '20px',
        width: '60%'
      },
      middleRight: {
        minHeight: 0,
        paddingLeft: 0,
        width: '73%'
      },
      right: {
        left: '137px',
        minHeight: 0,
        paddingLeft: 0,
        position: 'relative',
        width: '73%'
      }
    },
    square: {
      bottom: {
        minHeight: 0
      },
      bottomLeft: {
        minHeight: 0,
        paddingLeft: 0,
        width: '100%'
      },
      bottomRight: {
        minHeight: 0,
        paddingLeft: 0,
        width: '100%'
      },
      middle: {
        minHeight: 0
      },
      middleLeft: {
        minHeight: 0,
        paddingLeft: 0,
        width: '100%'
      },
      middleRight: {
        minHeight: 0,
        paddingLeft: 0,
        width: '100%'
      },
      top: {
        minHeight: 0
      }
    }
  },
  input: {
    flywire: {
      middleLeft: {
        borderRight: 0,
        borderBottomRightRadius: 0,
        borderTopRightRadius: 0,
        width: '100%'
      },
      middleRight: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        width: '100%'
      }
    },
    square: {
      bottom: {
        borderTop: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        height: '50px',
        width: '100%'
      },
      bottomLeft: {
        borderBottomRightRadius: 0,
        borderRight: 0,
        borderTop: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        height: '50px',
        width: '100%'
      },
      bottomRight: {
        borderBottomLeftRadius: 0,
        borderTop: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        height: '50px',
        width: '100%'
      },
      middle: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderTop: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        height: '50px',
        width: '100%'
      },
      middleLeft: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderRight: 0,
        borderTop: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        height: '50px',
        width: '100%'
      },
      middleRight: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderTop: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        height: '50px',
        width: '100%'
      },
      top: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        height: '50px',
        width: '100%'
      },
      errorBottom: {
        borderColor: '#cc0023',
        borderTop: '2px solid #cc0023',
        borderWidth: '2px'
      },
      errorBottomLeft: {
        borderColor: '#cc0023',
        borderRight: '2px solid #cc0023',
        borderTop: '2px solid #cc0023',
        borderWidth: '2px'
      },
      errorBottomRight: {
        borderColor: '#cc0023',
        borderTop: '2px solid #cc0023',
        borderWidth: '2px'
      },
      errorMiddle: {
        borderColor: '#cc0023',
        borderTop: '2px solid #cc0023',
        borderWidth: '2px'
      },
      errorMiddleLeft: {
        borderColor: '#cc0023',
        borderRight: '2px solid #cc0023',
        borderTop: '2px solid #cc0023',
        borderWidth: '2px'
      },
      errorMiddleRight: {
        borderColor: '#cc0023',
        borderTop: '2px solid #cc0023',
        borderWidth: '2px'
      },
      errorTop: {
        borderColor: '#cc0023',
        borderWidth: '2px'
      }
    }
  },
  wrapper: {
    flywire: {
      middleLeft: {
        display: 'inline-flex',
        minHeight: 0,
        paddingBottom: '5px',
        paddingLeft: '80px',
        width: '30%',
        verticalAlign: 'top'
      },
      middleRight: {
        display: 'inline-flex',
        minHeight: 0,
        paddingLeft: 0,
        width: '35%'
      }
    },
    square: {
      bottom: {
        minHeight: 0,
        paddingLeft: 0
      },
      bottomLeft: {
        display: 'inline-flex',
        minHeight: 0,
        paddingLeft: '16px',
        width: '35%'
      },
      bottomRight: {
        display: 'inline-flex',
        minHeight: 0,
        paddingLeft: 0,
        width: '25%'
      },
      middle: {
        minHeight: 0,
        paddingLeft: 0
      },
      middleLeft: {
        display: 'inline-flex',
        minHeight: 0,
        paddingLeft: '16px',
        width: '35%'
      },
      middleRight: {
        display: 'inline-flex',
        minHeight: 0,
        paddingLeft: 0,
        width: '25%'
      },
      top: {
        minHeight: 0,
        paddingLeft: 0
      }
    }
  }
};
var _default = exports["default"] = billingFormStyles;